<template>
  <div class="layout-main">
    <div class="layout-left">
      <left-sidebar ref="theme1LeftSidebar"></left-sidebar>
    </div>
    <div class="layout-right">
      <header-page ref="theme1HeaderPage"></header-page>
      <div class="content-box" :class="{ 'content-collapse': collapse }">
        <v-tags></v-tags>
        <div style="width: 100%;height: 10px;"></div><!-- 占位DIV -->
        <div class="content" :style="defaultHeight">
          <router-view v-slot="{ Component }">
            <transition name="move" mode="out-in">
              <keep-alive :include="tagsList">
                <component :is="Component" />
              </keep-alive>
            </transition>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerPage from './HeaderPage'
import LeftSidebar from './LeftSidebar'
import vTags from "../../Tags.vue";
export default {
  name: "index",
  data() {
    return {
      defaultHeight: {
        height: ""
      },
    };
  },
  components: {
    headerPage,
    LeftSidebar,
    vTags
  },
  watch: {
  },
  computed: {
    tagsList() {
      return this.$store.state.tagsList.map(item => item.name);
    },
    collapse() {
      return this.$store.state.collapse;
    }
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 87 + "px";
    },
  },
  created() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  }
}
</script>

<style scoped>
.content{
  background: #efefef;
}
</style>



// WEBPACK FOOTER //
// src/components/theme/theme1/index.vue